// Number, money and stage-colour helpers shared by the Sales CRM screens (the board, the pipeline
// analytics and sales performance), so a figure reads the same on every one of them.
import { DEFAULT_CURRENCY, currencySymbol } from "../../Shared/money.js";

// A compact amount in the company's own currency. Rupee companies read lakh/crore; others read
// thousand/million/billion. `company` is me.company from the company settings.
export function fmtCurrency(val, company) {
  const n = Number(val || 0);
  const symbol = currencySymbol(company);
  if ((company?.currency || DEFAULT_CURRENCY) === DEFAULT_CURRENCY) {
    if (n >= 10000000) return `${symbol}${(n / 10000000).toFixed(2)}Cr`;
    if (n >= 100000) return `${symbol}${(n / 100000).toFixed(2)}L`;
  } else {
    if (n >= 1000000000) return `${symbol}${(n / 1000000000).toFixed(2)}B`;
    if (n >= 1000000) return `${symbol}${(n / 1000000).toFixed(2)}M`;
  }
  if (n >= 1000) return `${symbol}${(n / 1000).toFixed(1)}K`;
  return `${symbol}${n.toLocaleString()}`;
}

export function fmtNum(n) {
  return Number(n || 0).toLocaleString();
}

export function pct(a, b) {
  if (!b) return "0%";
  return `${((a / b) * 100).toFixed(1)}%`;
}

export const STAGE_COLORS = {
  New: "var(--indigo-500)",
  "New Lead": "var(--indigo-500)",
  ContactAttempted: "var(--amber-500)",
  Connected: "var(--green-500)",
  MeetingScheduled: "var(--blue-500)",
  ProposalSent: "var(--indigo-500)",
  Negotiation: "var(--amber-600)",
  "Contact Attempted": "var(--amber-500)",
  Engaged: "var(--green-500)",
  "Discovery / Demo Scheduled": "var(--blue-500)",
  "Demo Done / Solution Fit": "var(--blue-600)",
  "Proposal Sent": "var(--indigo-500)",
  "Nurture / Recycle": "var(--indigo-500)",
  "Closed - Won": "var(--green-600)",
  ClosedWon: "var(--green-600)",
  "Closed - Lost": "var(--red-500)",
  ClosedLost: "var(--red-500)",
  "Closed - Cold": "var(--c-600)",
  ClosedCold: "var(--c-600)",
};

export function stageColor(stage) {
  return STAGE_COLORS[stage] || "var(--c-400)";
}
